import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import classNames from 'classnames';

import { getAsset } from '../../../../util/assets';

const propTypes = {
  isWeddings: PropTypes.bool,
  backdropSrc: PropTypes.string,
  contentClassName: PropTypes.string,
  headerClassName: PropTypes.string,
  backdropClassName: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.object]),
};

const SpecialtyEventUploadLayout = ({
  isWeddings,
  backdropSrc = '/onboarding-default-bg.jpg',
  contentClassName,
  headerClassName,
  backdropClassName,
  children,
}) => {
  const layoutContentClassNames = classNames({
    'specialty-event-upload-layout-content-wrap': true,
    'is-weddings': isWeddings,
    [contentClassName]: !!contentClassName,
  });

  const headerClasses = classNames({
    'specialty-event-upload-layout-header': true,
    [headerClassName]: !!headerClassName,
  });

  const backdropClasses = classNames({
    'specialty-event-upload-layout-backdrop': true,
    [backdropClassName]: !!backdropClassName,
  });

  return (
    <Fragment>
      <Helmet>
        <body className="body-specialty-event-upload" />
      </Helmet>

      <div className={headerClasses}>
        <div className="specialty-event-upload-layout-header-user-logo">
          <div className="specialty-event-upload-layout-header-waldo-logo" />
        </div>
      </div>

      <div className="specialty-event-upload-layout-wrap">
        <div className={layoutContentClassNames}>
          <div className="specialty-event-upload-layout-content-narrow">
            {children}
          </div>
        </div>
      </div>

      <div className={backdropClasses}>
        <img src={getAsset(backdropSrc)} alt="" />
      </div>
    </Fragment>
  );
};

SpecialtyEventUploadLayout.propTypes = propTypes;

export default SpecialtyEventUploadLayout;
